export default __webpack_public_path__ + "static/media/bottom-section-background.fd056667.svg";